import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../Config';
class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 30000;
    }

    // Login Page
    signUp = (request) =>{
        return  axios.post( 'sign-up', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Verify OTP Page
    signIn = (mobile , otp) =>{
       return  axios.post( 'sign-in', {mobile , otp}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //  Register Page
    updateProfile = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( 'users/update-profile', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserInfo = (params = null) => {
        return axios.get( `users/profiles/info`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getContent = (slug) => {
        return axios.get( `contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }



    //Orders History Page
    getOrders = (params = null) => {
        return axios.get( `orders`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Order  Detail  Page
    getOrder = (params = null , id) => {
        return axios.get( `orders/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    updateStatus = (request) =>{
        return  axios.patch( 'update-order-status', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Vendor Page
    getVendors = (params = null) => {
        return axios.get( `products/vendors`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getStatuses = (params = null) => {
        return axios.get( `statuses`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getDevices = (params = null) => {
        return axios.get( `vehicles/get-devices`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getCheckList = (params = null) => {
        return axios.get( `guard-checklist`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }




    storeOrder = (request) =>{
        return  axios.post( 'orders', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    storeVendor = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( 'products/vendors', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    updateVendor = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
        return  axios.post( 'products/update-vendor', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    editOrder = (request,id) =>{
        return  axios.put( `orders/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    uploadFile = (request,id) =>{

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

        return  axios.post( `orders/attach-document`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    removeFile = (id) =>{


        return  axios.delete( `orders/remove-document/${id}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getUsers = (params = null) => {
        return axios.get( `users/profiles`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    updateBOrder = (request = null , id) =>{
        return  axios.patch( `back-sales/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}
const API = new Api();
export default API;